import React, { useState } from "react";

const Page11 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left" style={{ paddingTop: '240px', paddingLeft: '150px' }}>        
        <img src="./img/module1/page11.svg" alt="" style={{ width: '90%' }} />
      </div>

      {/* DIREITA */}      
      <div className="moc-right" style={{ paddingTop: '100px' }}>
        <p><strong>RESPONSABILIDADES NO MOC</strong></p>
        <p>O Gerenciamento de Mudanças (MOC) depende de pessoas com papéis bem definidos. Para que uma mudança seja tratada de forma segura, cada envolvido precisa saber <strong>quando</strong> e <strong>como</strong> atuar.</p>
        <p>Quando responsabilidade não estão claras, o risco não está apenas na mudança, mas na forma como ela é conduzida. Pois isso, papéis bem definidos evitam decisões isoladas, análises incompletas e mudanças não formalizadas. </p>
        <p>Com isso em mente, vamos compreender melhor como papéis e responsabilidades podem tornar as mudanças mais seguras na sua realidade?</p>
      </div>

      <style>{`

        .container{
          width: 100% !important;
        }

        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA DIREITA */
        .moc-right {
          width: 50%;
          background: #ffffff;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        /* COLUNA ESQUERDA */
        .moc-left {
          width: 50%;
          padding-top: 250px;
          background: #c2c2c2;
          color: #000000;
          padding: 40px;
          box-sizing: border-box;        }

        .moc-left p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* ================= MOBILE ================= */
        @media (max-width: 768px) {

          .moc-page {
            flex-direction: column;
            // height: auto;
          }

          .moc-left,
          .moc-right {
            width: 100%;
            padding: 20px;
          }

          .moc-left {
            padding-top: 100px !important;
          }

          .moc-right {
            padding-top: 0px !important;
          }

          .moc-right img {
            width: 100%;
            max-width: 300px;
          }

        }

      `}</style>
    </div>
  );
};

export default Page11;